import React, { Component } from 'react';
import './SideBtn.css';
import image from "../../../images/public/userarea/tab1s.png";
import alerts from "../../../images/public/userarea/alerts.png";

class SideBtn extends Component {

    constructor(props) {
        super(props);

        super(props);
        this.text = props.text ? props.text : "Text missing!";
        this.imageUnselected = props.imageUnselected ? props.imageUnselected : image;
        this.imageSelected = props.imageSelected ? props.imageSelected : image;
        this.select = props.select ? props.select : false;
        this.alertside = props.alertside ? props.alertside : false;


        if (this.select) {
            /*this.colorText = "#28217a";*/
            this.colorText = "White";
            /*this.image = this.imageSelected;*/
            this.image = this.imageUnselected;

        }
        else {
            this.colorText = "White";
            this.image = this.imageUnselected;
        }

        this.state = {
            select: false,
        };

        //console.log("!!!!props btn ", props.select)
        this.onClick = this.onClick.bind(this);
    }



    onClick = () => {

        this.props.onClick();
    }

    render() {
        return (
            /*<div style={{ flex: 1 }}>
                <form style={{ flex: 1, }}>*/
                    <button disabled={this.props.disable} className={(this.props.select) ? "tabBtns" : "tabBtnu"} onClick={this.onClick}>
                      {this.props.alertside ?
                          <div className="alertssb">
                              <img src={alerts} className="responsive" />
                          </div> : null
                      }
                        <div className="tabImg">
                            <img src={this.image} />
                        </div>
                        <div style={{ color: this.colorText}} className="side_div">
                            <span>{this.text}</span>
                        </div>
                    </button>
               /* </form>
            </div>*/
        );
    }
}

export default SideBtn;



// WEBPACK FOOTER //
// ./src/assets/components/button/SideBtn.js